module.exports = __webpack_public_path__ + "img/plumbing-repair-03-xlarge.8ccff83d.jpg";